import {ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import { animateShow } from '@src/app/animations/showHideAnimation';
import {PreloadService} from '@src/app/services/preloadService/preload.service';
import {StoryService} from '@src/app/services/storyService/story.service';
import {fromEvent, timer} from 'rxjs';
import {filter} from 'rxjs/operators';

@Component({
  selector: 'app-edit-story-hidden-container',
  templateUrl: './edit-story-hidden-container.component.html',
  styleUrls: ['./edit-story-hidden-container.component.scss'],
  animations: [animateShow]
})
export class EditStoryHiddenContainerComponent implements OnInit {

  @ViewChild('element', {static: false}) element;

  @Input()
  set isOpened(val){
    this._isOpened = val;
    if (!val){
      this.position = {};
    }
  }
  get isOpened(){
    return this._isOpened;
  }
  @Input() story;
  @Input() position;
  @Output() renameStory = new EventEmitter<any>();

  private _isOpened;
  Yiit = Yiit;

  constructor(
    private cd: ChangeDetectorRef,
    private preload: PreloadService,
    private storyAdapter: StoryService
  ) { }

  ngOnInit() {
    fromEvent(window, 'click').pipe(filter(val => this.isOpened && this.element)).subscribe((event)=>{
      if (!this.element.nativeElement.contains(event.target) && !document.querySelector('.es-story-'+this.story.id+' .edit-story-container').contains(event.target as Node)) {
        this._isOpened = false;
        this.storyAdapter.inActivateEditMenu$ = true;
        this.cd.detectChanges();
      }
    })
  }

  ngOnChanges(some){
    console.log('position 2', this.position);

  }

  _renameStory(e){
    this.isOpened = false;
    this.cd.detectChanges();
    this.renameStory.emit(this.story);
  }

  removeStory(){
    if (window.confirm(Yiit.t('Are you sure?'))) {
      this.preload.preloadMessage$ = this.Yiit.t('Removing Presentation');
      this.preload.isPreloading$ = true;
      this.storyAdapter.removeStory(this.story).subscribe(()=>{
        this.isOpened = false;
        this.storyAdapter.inActivateEditMenu$ = true;
        this.preload.isPreloading$ = false;
        if (!this.cd['destroyed']) {
          this.cd.detectChanges();
        }
      });
    }
  }

  getPosition() {
    return this.position ? this.position : {};
  }
}
